// @ts-nocheck
import { Column } from 'react-table'
import { TitleCell } from './TitleCell'
import { UserCustomHeader } from './CustomHeader'
import moment from 'moment';
import { ActionCell } from './ActionCell';


const dashboardListColumns: ReadonlyArray<Column<User>> = [
  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title="Order Number" className='min-w-50px' />
    ),
    id: 'order_number',
    Cell: ({ ...props }) => <TitleCell userObj={props.data[props.row.index]?.order_number} />,
  },

  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title="Unique article count" className='min-w-50px' />
    ),
    id: 'total_records',
    Cell: ({ ...props }) => <TitleCell userObj={props.data[props.row.index]?.total_records} />,
  },

  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title='Delivery Date Request' className='min-w-50px' />
    ),
    id: 'requested_date',
    Cell: ({ ...props }) => {
      const rawDate = props.data[props.row.index]?.nearest_requested_date;
      const formattedDate = rawDate ? moment(rawDate).format("YYYY/MM/DD") : "-";
      return <TitleCell userObj={formattedDate} />;
    },
  },
  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title='Ordered Quantity' className='min-w-50px' />
    ),
    id: 'ordered_quantity',
    Cell: ({ ...props }) => <TitleCell userObj={props.data[props.row.index]?.ordered_quantity} />,
  },
  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title='Recieved Quantity' className='min-w-50px' />
    ),
    id: 'quantity_received',
    Cell: ({ ...props }) => <TitleCell userObj={props.data[props.row.index]?.quantity_received} />,
  },
  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title='Order OTIF' className='min-w-50px' />
    ),
    id: 'orderOTIF',
    Cell: ({ ...props }) => <TitleCell userObj={props.data[props.row.index]?.orderOTIF} />,
  },


  {
    Header: (props) => (
      <UserCustomHeader
        tableProps={props}
        title="Shipment Status"
        className="min-w-50px"
      />
    ),
    id: "deliveryStatus",
    Cell: ({ row, data }) => {
      const status = data[row.index]?.deliveryStatus || "Unknown";

      let displayStatus = status;
      let bgColor = "#6c757d"; // default gray

      if (status === "On Time") {
        displayStatus = "On Time";
        bgColor = "#28a745"; 
      } else if (status === "Late Delivery") {
        displayStatus = "Late Delivery";
        bgColor = "#fd7e14";
      } else if (status === "Order to ship") {
        displayStatus = "Order to ship"; 
        bgColor = "#17a2b8";
      }

      const badgeStyle = {
        display: "inline-block",
        padding: "4px 12px",
        borderRadius: "12px",
        backgroundColor: bgColor,
        color: "white",
        fontWeight: 600,
        textAlign: "center",
        minWidth: "150px",
        boxShadow: "0 1px 3px rgba(0,0,0,0.2)",
        transition: "all 0.2s ease",
      };

      return <span style={badgeStyle}>{displayStatus}</span>;
    },
  },


  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title='Azione' className='min-w-75px' />
    ),
    id: 'action',
    Cell: ({ ...props }) => <ActionCell user={props.data[props.row.index]} />,
  },
]

export { dashboardListColumns }
